export class MinimumOrderAmountNotMetError extends Error {
    constructor() {
        super('ERROR_MINIMUM_ORDER_AMOUNT_NOT_MET');
    }
}
